import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { View } from '@dbk/ui-react-utils';
import { TOUCHABLE_AREA_PERCENT_INNER } from './donut-chart-constants';

export default class DonutChartInner extends Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
    renderSelectedItem: PropTypes.func.isRequired,
    placeholderItem: PropTypes.object || PropTypes.node,
  };

  static defaultProps = {
    placeholderItem: undefined,
  };

  constructor(props) {
    super(props);

    this.state = { index: props.index };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ index: nextProps.index });
  }

  render() {
    const { items, renderSelectedItem, placeholderItem } = this.props;
    const { index } = this.state;
    const contentPercentMargin = TOUCHABLE_AREA_PERCENT_INNER * 100 + 8;

    let inner = null;

    const itemToRender = items && items[index] ? items[index] : placeholderItem;
    if (itemToRender) inner = renderSelectedItem(itemToRender);

    return (
      <View
        style={{
          position: 'absolute',
          left: `${contentPercentMargin}%`,
          right: `${contentPercentMargin}%`,
          top: `${contentPercentMargin}%`,
          bottom: `${contentPercentMargin}%`,
        }}
      >
        {inner}
      </View>
    );
  }
}
